mutation AddUserInbox($input: UserInboxAddInput!) {
    userInboxAdd(input: $input) {
        user {
            id
        }
    }
}
